export const ENDPOINT = 'http://www.tt-en.ru/ajax.php';
